import { useNavigate, useLocation } from 'react-router-dom'

/**
 * useMenuBack — returns a goBack function that re-opens the hamburger menu
 * if the current page was navigated to from the hamburger menu.
 * 
 * Usage: const goBack = useMenuBack()
 * Then use goBack() instead of navigate(-1) in the back button.
 * 
 * The hamburger menu passes { state: { fromMenu: true } } when navigating.
 * When going back, we navigate to the previous page and pass { state: { openMenu: true } }
 * so the parent page knows to re-open the hamburger.
 */
export default function useMenuBack() {
  const navigate = useNavigate()
  const location = useLocation()
  const fromMenu = location.state?.fromMenu === true

  return () => {
    if (fromMenu) {
      navigate(-1, { state: { openMenu: true } })
    } else {
      navigate(-1)
    }
  }
}
